(function () {
  function getPerView(wrapper) {
    const css = getComputedStyle(wrapper);
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const val = isMobile
      ? css.getPropertyValue("--perview-mobile")
      : css.getPropertyValue("--perview-desktop");
    const n = parseInt(val, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  // Modo filas en teléfono: el viewport se desliza por dentro y un medidor a la
  // derecha muestra en qué parte de la lista se va.
  function initBarra(wrap, viewport) {
    const barra  = wrap.querySelector("[data-catcar-barra]");
    const cursor = wrap.querySelector("[data-catcar-cursor]");
    if (!barra || !cursor) return;
    function pintar() {
      const total = viewport.scrollHeight, alto = viewport.clientHeight;
      if (total <= alto + 1) { barra.style.display = "none"; wrap.classList.remove("catcar__wrap--desliza"); return; }
      barra.style.display = ""; wrap.classList.add("catcar__wrap--desliza");
      wrap.style.setProperty("--catcar-barra-alto", alto + "px");
      const h = Math.max(24, alto * alto / total);
      cursor.style.height = h + "px";
      cursor.style.top = (viewport.scrollTop / (total - alto)) * (alto - h) + "px";
    }
    viewport.addEventListener("scroll", pintar, { passive: true });
    window.addEventListener("resize", pintar);
    if ("ResizeObserver" in window) new ResizeObserver(pintar).observe(viewport);
    pintar();
  }

  function initCarousel(root) {
    const wrap     = root.querySelector("[data-catcar]");
    const viewport = root.querySelector("[data-catcar-viewport]");
    const rail     = root.querySelector("[data-catcar-rail]");
    const btnPrev  = root.querySelector("[data-catcar-prev]");
    const btnNext  = root.querySelector("[data-catcar-next]");
    const dotsWrap = root.querySelector("[data-catcar-dots]");
    if (!wrap || !viewport || !rail || !btnPrev || !btnNext || !dotsWrap) return;
    if (wrap.dataset.catcarLayout === "grid") { initBarra(wrap, viewport); return; } // modo filas: sin paginar

    const cards = Array.from(rail.querySelectorAll(".catcar__card"));

    function pageWidth()  { return viewport.clientWidth || 1; }
    function pagesCount() { return Math.max(1, Math.ceil(cards.length / getPerView(wrap))); }
    function currentPage() {
      const w = pageWidth();
      return Math.max(0, Math.min(pagesCount() - 1, Math.floor((viewport.scrollLeft + w * 0.5) / w)));
    }

    function scrollToPage(p) {
      const total = pagesCount();
      const next  = Math.max(0, Math.min(total - 1, p));
      viewport.scrollTo({ left: next * pageWidth(), behavior: "smooth" });
    }

    function renderDots() {
      const total  = pagesCount();
      const active = currentPage();
      dotsWrap.innerHTML = "";
      for (let i = 0; i < total; i++) {
        const b = document.createElement("button");
        b.type      = "button";
        b.className = "catcar__dot" + (i === active ? " is-active" : "");
        b.setAttribute("aria-label", "Ir a página " + (i + 1));
        b.addEventListener("click", () => scrollToPage(i));
        dotsWrap.appendChild(b);
      }
    }

    function updateArrows() {
      const p     = currentPage();
      const total = pagesCount();
      btnPrev.disabled = p <= 0;
      btnNext.disabled = p >= total - 1;
    }

    function syncUI() { renderDots(); updateArrows(); }

    btnPrev.addEventListener("click", () => scrollToPage(currentPage() - 1));
    btnNext.addEventListener("click", () => scrollToPage(currentPage() + 1));

    let scrollDebounce;
    viewport.addEventListener("scroll", () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(syncUI, 80);
    }, { passive: true });

    window.addEventListener("resize", syncUI);

    syncUI();
  }

  function initAll() {
    document.querySelectorAll("[data-catcar-section]").forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Soporte editor de Shopify
  document.addEventListener("shopify:section:load", function (e) {
    const root = e.target && e.target.querySelector
      ? (e.target.querySelector("[data-catcar-section]") || (e.target.matches?.("[data-catcar-section]") ? e.target : null))
      : null;
    if (root) initCarousel(root);
  });
})();
